/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1200px){.btn[_ngcontent-%COMP%]{color:#fff;width:40px;height:40px;padding:0}}"];
export { styles as styles };
